// extracted by mini-css-extract-plugin
export var columnList = "_ba-0";